import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BriefcaseOutline: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.6635 3.53333H14.9581V1.63726C14.9581 0.734446 14.2236 0 13.3208 0H8.51662C7.61381 0 6.87932 0.734446 6.87932 1.63726V3.53333H2.17391C0.975188 3.53333 0 4.50856 0 5.70725V16.8261C0 18.0248 0.975188 19 2.17391 19H19.6635C20.8622 19 21.8375 18.0248 21.8375 16.8261V5.70725C21.8375 4.50856 20.8622 3.53333 19.6635 3.53333ZM8.26613 1.63726C8.26613 1.49914 8.3785 1.38681 8.51662 1.38681H13.3208C13.4589 1.38681 13.5713 1.49919 13.5713 1.63726V3.53333H8.26613V1.63726ZM1.38681 5.70725C1.38681 5.27322 1.73988 4.92014 2.17391 4.92014H19.6635C20.0975 4.92014 20.4506 5.27322 20.4506 5.70725V6.73353C20.4506 7.69615 19.8052 8.55636 18.8809 8.82545L11.6286 10.937C11.1642 11.0723 10.6733 11.0723 10.2088 10.937L2.95651 8.8254C2.03228 8.55632 1.38681 7.69615 1.38681 6.73353V5.70725ZM19.6635 17.6132H2.17391C1.73993 17.6132 1.38681 17.2602 1.38681 16.8262V9.55695C1.73624 9.82703 2.13456 10.0305 2.56881 10.157C10.5802 12.4895 10.1684 12.4253 10.9187 12.4253C11.6789 12.4253 11.2479 12.4922 19.2686 10.157C19.7029 10.0305 20.1012 9.82703 20.4506 9.55695V16.8261C20.4506 17.2601 20.0975 17.6132 19.6635 17.6132Z"
        fill="currentColor"
      />
    </svg>
  )
})

BriefcaseOutline.displayName = 'BriefcaseOutline'
